import {
  SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_BEGIN,
  SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_SUCCESS,
  SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_FAILURE,
  SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function removeCategoryChildPosition(params = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
     request({
         method: 'post',
        url: '/api/b/position/category/movesub',
        data: params,
      }).then(
        (res) => {
          dispatch({
            type: SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissRemoveCategoryChildPositionError() {
  return {
    type: SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeCategoryChildPositionPending: true,
        removeCategoryChildPositionError: null,
      };

    case SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_SUCCESS:
      // The request is success
      return {
        ...state,
        removeCategoryChildPositionPending: false,
        removeCategoryChildPositionError: null,
      };

    case SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_FAILURE:
      // The request is failed
      return {
        ...state,
        removeCategoryChildPositionPending: false,
        removeCategoryChildPositionError: action.data.error,
      };

    case SYSTEM_REMOVE_CATEGORY_CHILD_POSITION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeCategoryChildPositionError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/removeCategoryChildPosition.js